import { render, staticRenderFns } from "./ccOsTargetingSelect.vue?vue&type=template&id=39968dad"
import script from "./ccOsTargetingSelect.vue?vue&type=script&lang=js"
export * from "./ccOsTargetingSelect.vue?vue&type=script&lang=js"
import style0 from "./ccOsTargetingSelect.vue?vue&type=style&index=0&id=39968dad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports